import React, { useEffect } from 'react';
import { Body, FormCadastro, PageHeader, Switch, Field, GroupField, Input, Spin, View } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getComando } from '@ducks/conectoresComandos';

import App from '@app';

export default function Detalhes() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { idConfiguracao, id } = useParams();
  const comando = useSelector(({ conectoresComandos }) => conectoresComandos.get('comando'));
  const successComando = useSelector(({ conectoresComandos }) => conectoresComandos.get('successComando'));
  const loadingComando = useSelector(({ conectoresComandos }) => conectoresComandos.get('loadingComando'));

  const handleSearch = () => {
    return dispatch(getComando(idConfiguracao, id));
  };

  useEffect(() => {
    if (comando) {
      form.setFieldsValue(comando);
    }
  }, [successComando]);

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <App>
      <Body>
        <PageHeader title="Comando" onBack={() => history.goBack()}>
          <FormCadastro form={form}>
            {loadingComando ? (
              <Spin />
            ) : (
              <View>
                <GroupField>
                  <Field label="Tipo do comando" name="dsComando">
                    <Input disabled />
                  </Field>
                  <Field label="Data do comando" name="dt">
                    <Input disabled />
                  </Field>
                  <Field label="Executado" name="executado" valuePropName="checked">
                    <Switch disabled />
                  </Field>
                  <Field label="Data de Execução" name="dtExecucao">
                    <Input disabled />
                  </Field>
                </GroupField>
                <GroupField>
                  <Field label="Comando" name="comando">
                    <Input.TextArea rows={5} disabled />
                  </Field>
                </GroupField>
                <GroupField>
                  <Field label="Retorno" name="retorno">
                    <Input.TextArea rows={5} disabled />
                  </Field>
                </GroupField>
              </View>
            )}
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
